var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTasksIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39551 17.875C9.39551 17.4953 9.70331 17.1875 10.083 17.1875H19.2497C19.6294 17.1875 19.9372 17.4953 19.9372 17.875C19.9372 18.2547 19.6294 18.5625 19.2497 18.5625H10.083C9.70331 18.5625 9.39551 18.2547 9.39551 17.875Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39551 11.4583C9.39551 11.0786 9.70331 10.7708 10.083 10.7708H19.2497C19.6294 10.7708 19.9372 11.0786 19.9372 11.4583C19.9372 11.8379 19.6294 12.1458 19.2497 12.1458H10.083C9.70331 12.1458 9.39551 11.8379 9.39551 11.4583Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39551 5.0415C9.39551 4.66181 9.70331 4.354 10.083 4.354H19.2497C19.6294 4.354 19.9372 4.66181 19.9372 5.0415C19.9372 5.4212 19.6294 5.729 19.2497 5.729H10.083C9.70331 5.729 9.39551 5.4212 9.39551 5.0415Z",
    fill: "#F1F1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9028 2.72212C7.17129 2.9906 7.17129 3.4259 6.9028 3.69439L4.1528 6.44439C3.88432 6.71287 3.44902 6.71287 3.18053 6.44439L2.26386 5.52772C1.99538 5.25924 1.99538 4.82393 2.26386 4.55545C2.53235 4.28696 2.96765 4.28696 3.23614 4.55545L3.66667 4.98598L5.93053 2.72212C6.19902 2.45363 6.63432 2.45363 6.9028 2.72212Z",
    fill: "#F1F1F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9028 9.13886C7.17129 9.40735 7.17129 9.84265 6.9028 10.1111L4.1528 12.8611C3.88432 13.1296 3.44902 13.1296 3.18053 12.8611L2.26386 11.9445C1.99538 11.676 1.99538 11.2407 2.26386 10.9722C2.53235 10.7037 2.96765 10.7037 3.23614 10.9722L3.66667 11.4027L5.93053 9.13886C6.19902 8.87038 6.63432 8.87038 6.9028 9.13886Z",
    fill: "#F1F1F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9028 15.5554C7.17129 15.8239 7.17129 16.2592 6.9028 16.5276L4.1528 19.2776C3.88432 19.5461 3.44902 19.5461 3.18053 19.2776L2.26386 18.361C1.99538 18.0925 1.99538 17.6572 2.26386 17.3887C2.53235 17.1202 2.96765 17.1202 3.23614 17.3887L3.66667 17.8192L5.93053 15.5554C6.19902 15.2869 6.63432 15.2869 6.9028 15.5554Z",
    fill: "#F1F1F1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksIcon);
export default __webpack_public_path__ + "static/media/tasks-icon.0e3546c8ddf62dd194b05c277cfeb435.svg";
export { ForwardRef as ReactComponent };